import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./CoinsPopup.css";

import coins from "../imagesHome/coins.png";

const CoinsPopup = ({ coinCount }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="popup-question-container">
      <button
        type="button"
        className="oriented-question-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide popup monede"
      >
        <img src={coins} className="coins-popup-icon" draggable={false} alt="Monede" />
        <div className="value-coins">{coinCount}</div>
      </button>

      {isVisible &&
        createPortal(
          <>
            <div className={`popup-question-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
            <div
              className={`popup-question ${isOpen ? "open" : ""}`}
              role="dialog"
              aria-modal="true"
              aria-label="Detalii monede"
            >
              <button type="button" className="popup-question-close" onClick={closePopup}>×</button>
              <div className="popup-question-content">
                <div className="coins-popup-number">{coinCount}</div>
                <img src={coins} className="coins-popup-bigicon" draggable={false} alt="Monede" />
                <h3>Ai {coinCount} monede</h3>
                <p>Poți folosi monedele pentru a debloca lecții sau ajutoare.</p>
                <button type="button" className="coins-popup-btn">Cumpără monede</button>
              </div>
            </div>
          </>,
          document.body
        )}
    </div>
  );
};

export default CoinsPopup;
